'use strict';

import React from 'react'

import _ from 'lodash'

import getFormStatus from '@/Form/Functions/getFormStatus'

import Modal from '@Modal/Modal'

import AddCustomQuoteElement from '@/CustomQuote/AddCustomQuoteElement'

import Loader from '@Pure/Loader'

let app = window.app;

export default class CustomQuoteItemModal extends React.Component
{
	constructor (props)
	{
		super(props);

		this.state = { };
	}

	componentWillMount ()
	{
		const component = this, props = this.props, state = this.state;

		app.push(
		{
			event: 'open__CustomQuoteItemModal',
			cb: component.open
		});

		component.setState(
		{
			open: false,
			element: undefined
		});
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props, state = this.state;

		app.delete(
		{
			event: 'open__CustomQuoteItemModal',
			cb: component.open
		});
	}

	open = (element) =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState(
		{
			open: true,
			loading: false,

			element: element || undefined,

			info: undefined,
			error: undefined,
			warning: undefined
		});
	}

	handleClose = (e, force) =>
	{
		const component = this, props = this.props, state = this.state;

		if (state.loading === true && !force)
		{
			return e && e.stopPropagation();
		}

		component.setState(
		{
			open: false,
			loading: false
		});
	}

	handleAddedElement = (element, update) =>
	{
		const component = this, props = this.props, state = this.state;

		if (update === true)
		{
			app.emit('updatedCustomQuoteItem', element);
		}
		else
		{
			app.emit('addedCustomQuoteItem', element);
		}

		component.handleClose();
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		let loader, status = getFormStatus(state);

		if (state.loading === true)
		{
			loader = <Loader className="c-loader" bemit={ ['white', 'bg-primary'] } />;
		}

		let add_component;

		if (state.open === true)
		{
			add_component =
			(
				<AddCustomQuoteElement onAdd={ component.handleAddedElement }
					element={ state.element } />
			);
		}

		let output =
		(
			<Modal className="o-modal o-modal--large" open={ state.open } hide_close={ true }
				onClose={ component.handleClose }
				title={ state.element ? 'Modifier un champ' : 'Ajouter un champ' }>

				{ add_component }

				{ status }

				<div className="c-dialog__buttons">
					<button type="button" className="c-btn c-dialog__cancel u-margin-right-0"
						onClick={ component.handleClose }>
						Annuler
					</button>
				</div>

				{ loader }

			</Modal>
		);

		return output;
	}
}